export default __webpack_public_path__ + "static/media/trr-food-handheld-classic.544540bc.png";